import http from '@/plugins/axios/axios';

export default class RelatorioService {
    
    clienteIK(requisicao) {
        return http.post('/api/amd/relatorio/cliente/pdf', requisicao);
    }

    clienteIKXls(requisicao) {
        return http.post('/api/amd/relatorio/cliente/xls', requisicao);
    }

}